import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-promo-codes-dialog',
  templateUrl: './promo-codes-dialog.component.html',
  styleUrls: ['./promo-codes-dialog.component.scss']
})
export class PromoCodesDialogComponent implements OnInit {

  heading: string | undefined;
  promoList: [] = [];
  constructor(
    @Inject(MAT_DIALOG_DATA) public _data: any,
    public _matDialogRef: MatDialogRef<PromoCodesDialogComponent>,
  ) {
    this.heading = this._data.heading;
    this.promoList = this._data.promoList;
    // console.log("this.promoList",  this.promoList);
  }

  ngOnInit(): void {
  }

}
